import { render, staticRenderFns } from "./curtain.vue?vue&type=template&id=5041057d&"
import script from "./curtain.vue?vue&type=script&lang=js&"
export * from "./curtain.vue?vue&type=script&lang=js&"
import style0 from "./curtain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports